import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Calendar, Bookmark, Flame, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/dashboard", label: "Home", icon: Home, end: true },
  { to: "/my-classes", label: "My Classes", icon: Calendar },
  { to: "/my-dances", label: "My Dances", icon: Bookmark },
  { to: "/whats-on", label: "What's On", icon: Flame },
  { to: "/account", label: "Account", icon: User },
];

export function BottomNav() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-[#FAF7F2]/95 backdrop-blur-md md:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} data-testid={`bottomnav-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-semibold ${isActive ? "text-[#B04B26]" : "text-[#6E5B51]"}`}>
            <Icon size={22} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
